// Shared helpers for chat section mappings and labels

export const getSectionNameToKey = (type: string): Record<string, string> => {
    if (type === 'icp') {
        return {
            'Must-Haves': 'must_have',
            'Should-Haves': 'should_have',
            'Good-to-Haves': 'good_to_have',
            "Won't-Haves": 'wont_have',
            'Could-Haves': 'could_have',
        };
    } else if (type === 'job' || type === 'general') {
        return {
            'Job Title': 'job_title',
            'Job_title': 'Job Title',
            'Alternate job titles': 'alternate_titles',
            'Alternative job titles': 'Alternate job titles',
            'What are the day-to-day responsibilities of the role?': 'What are the day-to-day responsibilities of the role?',
            'What are the value-plus goals of this position?': 'value_plus_goals',
            'Skills': 'skills',
            'Industries': 'industries',
            'Years of experience': 'experience',
            'Education': 'education',
            'Licenses & Certifications': 'licenses_certifications',
            'Spoken Language': 'spoken_language',
            'What would you be working on?': 'work_activities',
            'What would you work on?': 'work_activities',
            'How do you approach your work?': 'work_approach',
            'Prior company name brand advantage': 'company_advantage',
            'Citizenship / Work authorization': 'work_authorization',
            'Security clearance': 'security_clearance',
            'How would you work?': 'work_arrangement',
            'Employment Type': 'employment_type',
            'Work from': 'work_location',
            'Location': 'location',
            'Distance': 'distance',
            'Time Zone': 'time_zone',
        };
    }
    return getSectionNameToKey('job');
};

export const getSectionOptions = (type: string): Array<{ key: string; label: string }> => {
    if (type === 'icp') {
        return [
            { key: 'must_have', label: 'Must-Haves' },
            { key: 'should_have', label: 'Should-Haves' },
            { key: 'good_to_have', label: 'Good-to-Haves' },
            { key: 'wont_have', label: "Won't-Haves" },
        ];
    } else if (type === 'job') {
        return [
            { key: 'job_title', label: 'Job Title' },
            { key: 'alternate_titles', label: 'Alternate job titles' },
            { key: 'responsibilities', label: 'Day-to-day responsibilities' },
            { key: 'value_plus_goals', label: 'Value-plus goals' },
            { key: 'skills', label: 'Skills' },
            { key: 'industries', label: 'Industries' },
            { key: 'experience', label: 'Years of experience' },
            { key: 'education', label: 'Education' },
            { key: 'licenses_certifications', label: 'Licenses & Certifications' },
            { key: 'spoken_language', label: 'Spoken Language' },
            { key: 'work_activities', label: 'Work activities' },
            { key: 'work_approach', label: 'Work approach' },
            { key: 'company_advantage', label: 'Company advantage' },
            { key: 'work_authorization', label: 'Work authorization' },
            { key: 'security_clearance', label: 'Security clearance' },
            { key: 'work_arrangement', label: 'Work arrangement' },
            { key: 'employment_type', label: 'Employment Type' },
            { key: 'work_location', label: 'Work location' },
            { key: 'location', label: 'Location' },
            { key: 'distance', label: 'Distance' },
            { key: 'time_zone', label: 'Time Zone' },
        ];
    }
    return [];
};

export const getFieldLabelFromKey = (key: string, type: string = 'job'): string => {
    const options = getSectionOptions(type);
    const found = options.find(o => o.key === key);
    return found ? found.label : key;
};

// Constants for prioritizing and filtering chat options
export const PRIORITY_LABELS = [
    'Skills',
    'Education',
    'What are the day-to-day responsibilities of the role?',
    'What are the day to day responsibilities for the role?',
    'What would you be working on?',
    'What would you work on?'
];

export const PRIORITY_KEYS = [
    'skills',
    'education',
    'responsibilities',
    'work_on',
    'work_activities'
];

export const RESPONSIBILITIES_KEYS = ['responsibilities'];

export const RESPONSIBILITIES_LABELS = [
    'What are the day-to-day responsibilities of the role?',
    'What are the day to day responsibilities for the role?'
];

export const AUTO_POPULATE_FIELDS = [
    'Job_title',
    'Alternate job titles', 
    'What are the day to day responsibilities for the role?',
    'What are the day-to-day responsibilities of the role?',
    'What are the value-plus goals of this position?'
];

